import { Link } from 'react-router-dom';
import { newMovies } from '@/mocks/movies';
import MovieCard from './MovieCard';

export default function LatestMovies() {
  return (
    <section className="w-full px-4 md:px-6 py-12 md:py-16">
      <div className="flex items-center justify-between mb-8">
        <div>
          <h3 className="text-2xl md:text-3xl font-bold font-heading text-foreground-50 mb-2">
            最新上线
          </h3>
          <p className="text-sm text-foreground-500">及时更新，精彩不等待</p>
        </div>
        <Link
          to="/category/kehuan"
          className="hidden sm:flex items-center gap-1 text-sm text-primary-500 hover:text-primary-400 transition-colors whitespace-nowrap"
        >
          查看更多
          <div className="w-4 h-4 flex items-center justify-center">
            <i className="ri-arrow-right-line text-xs"></i>
          </div>
        </Link>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-3 md:gap-4">
        {newMovies.map((movie) => (
          <MovieCard key={movie.id} movie={movie} />
        ))}
      </div>
    </section>
  );
}